import React, { ReactElement } from 'react'
import { WrestlerSmallView } from './WrestlerSmallView'
import { TagChampsSmallView } from './TagChampsSmallView'
import { URLS } from '../../content/urls'

export const Vakant: React.FC<{ title: string | null }> = ({ title }) => {
  // TODO: Add profilbild URL to vakant Wrestler image
  return (
    <WrestlerSmallView
      profilbild={URLS.vakantWrestlerImage}
      name={'Vakant'}
      onClick={(): void => {
        console.log("Ain't no f*n information bout a vakant dude, man!")
      }}
      title={title}
      bigFont={true}
    />
  )
}

export const VakantTagChamps = (): ReactElement => {
  return (
    <TagChampsSmallView
      profilbilder={[URLS.vakantWrestlerImage, URLS.vakantWrestlerImage]}
      namen={['Vakant', 'Vakant']}
      firstStables={['Vakant']}
      secondStables={['Vakant']}
      onFirstClick={(): void => {
        console.log("Ain't no f*n information bout a vakant team, man!")
      }}
      onSecondClick={(): void => {
        console.log("Ain't no f*n information bout a vakant team, man!")
      }}
    />
  )
}
